import {CdFrequencyItem} from '../../../interfaces/care/cd-care-plan/cd-frequency-item';
import {CdFrequencyItemType} from '../../../enums/care/cd-care-plan/cd-frequency-item-type';

export class CdFrequencyItemFactory {
  /**
   *
   * @param cdFrequencyItem
   */
  public static fromObject(cdFrequencyItem: any): CdFrequencyItem {
    return new class implements CdFrequencyItem {
      id: number = cdFrequencyItem.id;
      type: CdFrequencyItemType = cdFrequencyItem.type;
      cdFrequencyId: number = cdFrequencyItem.pivot?.c_frequency_id;
      parentId: number = cdFrequencyItem.pivot?.c_care_plan_item_id;
    };
  }

  /**
   *
   *
   * @param cdFrequencyItemEvents
   */
  public static fromArray(cdFrequencyItemEvents: any[]): CdFrequencyItem[] {
    return cdFrequencyItemEvents.map(_cdFrequencyItemEvent => CdFrequencyItemFactory.fromObject(_cdFrequencyItemEvent));
  }
}
